import { useState } from "react";
import useObjectInput from "../../../hooks/useObjectInput";

// custom hook to handle the GOINode related functionality
const useGOINode = (inputData, parentCb, editMode, onEditCb) => {
  // context state
  const { saveData, onInputValueChange, idValuePair } =
    useObjectInput();

  // local state
  const [state, setState] = useState({
    activeTab: "",
    isSaving: false,
  });

  const { activeTab, isSaving } = state;

  const onStateChange = (key, value) => {
    setState({ ...state, [key]: value });
  };

  const handleValueChange = (e) => {
    let inputValue;
    // if the input is a file, get the file name and size
    if (inputData.class === "File") {
      // e.target will be undefined was dropped in the dropzone
      inputValue = e.target
        ? { name: e.target.value.name, size: e.target.value.size }
        : { name: e[0].name, size: e[0].size };
    } else {
      inputValue = e.target.value;
    }
    onInputValueChange(inputData.id, inputValue);
  };

  // create the request data
  const createRequestData = () => {
    const val = idValuePair[inputData.id];
    let requestData = {
      triggerObject: {
        id: inputData.id,
        value:
          inputData.class === "Integer" || inputData.class === "Float"
            ? Number(val)
            : val,
      },
      associatedObjects: [],
    };
    return requestData;
  };

  const callback = () => {
    setState({
      ...state,
      isSaving: false,
      editMode: inputData.hide ? true : false,
    });
    if (onEditCb) {
      onEditCb();
    }
    if (parentCb) parentCb("post", "success");
  };

  const errorCallback = () => {
    setState({ ...state, isSaving: false, editMode: true });
    if (parentCb) parentCb("post", "error");
    if (onEditCb) {
      onEditCb();
    }
  };

  const handleSaveBtnClick = () => {
    if (parentCb) parentCb("pre", "success");
    const data = createRequestData();
    setState({ ...state, isSaving: true });
    saveData(data, inputData.class, callback, errorCallback);
  };

  return {
    activeTab,
    editMode,
    handleSaveBtnClick,
    handleValueChange,
    setState,
    isSaving,
    onStateChange,
  };
};

export default useGOINode;
